import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMarketPlaces } from "../../../../redux/actions/marketplacesActions";
import { getEcommercePlaces } from "../../../../redux/actions/ecommercePlaceActions";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  CardMedia,
  styled,
  IconButton,
  CardHeader,
  Badge,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  LinearProgress,
  Pagination,
  Stack,
  Button,
  Checkbox,
  Backdrop,
  Avatar,
  Alert,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Cancel,
  CheckCircle,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";
import outWardService from "../../../../services/outWardService";
import marketplacesService from "../../../../services/marketplacesService";
import ecommercePlaceService from "../../../../services/ecommercePlaceService";
import productService from "../../../../services/productService";
import { unwrapThunkList } from "../../../../utils/helpers";
import AddCategory from "./addCategory";
import useAlert from "../../../../hooks/useAlert";
import ProductMatchingModal from "./ProductMatchingModal";
const StyledCard = styled(Card)(({ theme, selected, colorcode }) => ({
  cursor: "pointer",
  minWidth: "120px",
  height: "100px",
  margin: "0 8px",
  transition: "all 0.3s ease",
  border: selected
    ? `2px solid ${colorcode || theme.palette.primary.main}`
    : "2px solid transparent",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: theme.shadows[2],
  },
  [theme.breakpoints.down("sm")]: {
    minWidth: "100px",
    height: "90px",
    margin: "0 4px",
  },
}));

const SliderContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  padding: "0 40px",
  [theme.breakpoints.down("sm")]: {
    padding: "0 30px",
  },
}));

const ScrollContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  overflowX: "hidden",
  scrollBehavior: "smooth",
  padding: "16px 0",
  [theme.breakpoints.down("sm")]: {
    padding: "12px 0",
  },
}));

const ScrollButton = styled(IconButton)(({ theme, direction }) => ({
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 1,
  backgroundColor: "white",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  ...(direction === "left" ? { left: 0 } : { right: 0 }),
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "4px",
    "& svg": {
      fontSize: "1.2rem",
    },
  },
}));
export const PlaceProducts = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isDesktop = useMediaQuery(theme.breakpoints.down("lg"));
  const isLargeDesktop = useMediaQuery(theme.breakpoints.down("xl"));
  const [allPlaces, setAllPlaces] = useState([]);
  const [error, setError] = useState(null);
  const [products, setProducts] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalPage, setTotalpage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingPleaces, setLoadingPleaces] = useState(false);
  const [ecommerceAccounts, setEcommerceAllAccounts] = useState([]);
  const [marketpleacesAccounts, setMarketpleacesAllAccounts] = useState([]);
  const dispatch = useDispatch();
  const userId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [openCategoryAdd, setOpenCategoryAdd] = useState(false);
  const [openProductMatching, setOpenProductMatching] = useState(false);
  const [selectedMatchingProduct, setSelectedMatchingProduct] = useState(null);
  const { showErrorAlertAll, showSuccessAlertAllNoReload } = useAlert();
  const [sendLoading, setsendLoading] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [showFilterAlert, setShowFilterAlert] = useState(false);
  const [filterProductName, setFilterProductName] = useState("");
  const [filterCategoryName, setFilterCategoryName] = useState("");
  const [isFilterActive, setIsFilterActive] = useState(false);
  const handleOpenModal = () => {
    setOpenCategoryAdd(true);
  };
  const handleCloseModal = () => {
    setOpenCategoryAdd(false);
  };

  const handleOpenMatchingModal = () => {
    setOpenProductMatching(true);
  };
  const handleCloseMatchingModal = () => {
    setOpenProductMatching(false);
  };

  useEffect(() => {
    const fetchPlatforms = async () => {
      try {
        setLoadingPleaces(true);
        const [marketResponse, ecommerceResponse] = await Promise.all([
          dispatch(getMarketPlaces(token)),
          dispatch(getEcommercePlaces(token)),
        ]);
        const marketList = unwrapThunkList(marketResponse);
        const ecommerceList = unwrapThunkList(ecommerceResponse);
        const combinedData = [
          ...marketList.map((item) => ({
            ...item,
            type: "marketplace",
          })),
          ...ecommerceList.map((item) => ({
            ...item,
            type: "ecommerce",
          })),
        ];
        setAllPlaces(combinedData);
        setLoadingPleaces(false);
      } catch (err) {
        setLoadingPleaces(false);
        setError(err.message || "Veriler alınırken hata oluştu.");
      }
    };
    fetchPlatforms();
  }, [dispatch]);

  const [selectedPlace, setSelectedPlace] = useState(null);
  const scrollRef = React.useRef(null);
  const tableContainerRef = React.useRef(null);
  const topScrollBarRef = React.useRef(null);

  // Tablonun genişliğini tahmin etmek için fonksiyon
  const getTableWidth = () => {
    // Tahmini sütun genişlikleri
    const columnWidths = {
      checkbox: 50, // Checkbox sütunu
      barcode: 150, // Barkod sütunu
      product: 250, // Ürün sütunu
      brand: 130, // Marka sütunu
      stockCode: 150, // Stok Kodu sütunu
      price: 130, // Fiyat sütunu
      status: 130, // Durum sütunu
      category: 150, // Kategori sütunu
      attributes: 180, // Özellikler sütunu
      actions: 200, // İşlemler sütunu
    };

    // Tüm sütunların toplam genişliği
    const totalWidth = Object.values(columnWidths).reduce((a, b) => a + b, 0);
    return totalWidth || 1520; // Varsayılan 1520px
  };

  // Üst scroll bar ile tablo içeriğini senkronize etmek için useEffect
  useEffect(
    () => {
      const topScrollBar = topScrollBarRef.current;
      const tableContainer = tableContainerRef.current;

      if (topScrollBar && tableContainer) {
        // Scroll bar'a kaydırınca tabloyu da kaydır
        const handleTopScroll = () => {
          tableContainer.scrollLeft = topScrollBar.scrollLeft;
        };

        // Tabloyu kaydırınca scroll bar'ı da kaydır
        const handleTableScroll = () => {
          topScrollBar.scrollLeft = tableContainer.scrollLeft;
        };

        // Olay dinleyicilerini ekle
        topScrollBar.addEventListener("scroll", handleTopScroll);
        tableContainer.addEventListener("scroll", handleTableScroll);

        // Temizleme işlemi
        return () => {
          topScrollBar.removeEventListener("scroll", handleTopScroll);
          tableContainer.removeEventListener("scroll", handleTableScroll);
        };
      }
    },
    [
      /* Her render'da yeniden bağla */
    ]
  );

  // Sayfa yüklendiğinde ve pencere boyutu değiştiğinde scroll bar genişliğini güncelle
  useEffect(() => {
    const updateScrollBarWidth = () => {
      const topScrollBar = topScrollBarRef.current;
      if (topScrollBar) {
        const scrollBarContent = topScrollBar.querySelector("div");
        if (scrollBarContent) {
          scrollBarContent.style.width = `${getTableWidth()}px`;
        }
      }
    };

    // Sayfa ilk yüklemesinde güncelle (500ms gecikme ile)
    const initialTimeout = setTimeout(() => {
      updateScrollBarWidth();
    }, 500);

    // Pencere boyutu değiştiğinde güncelle
    window.addEventListener("resize", updateScrollBarWidth);

    return () => {
      clearTimeout(initialTimeout);
      window.removeEventListener("resize", updateScrollBarWidth);
    };
  }, []);

  // Products yüklenince scroll bar genişliğini güncelle
  useEffect(() => {
    if (products?.length > 0) {
      const updateScrollBarWidth = () => {
        const topScrollBar = topScrollBarRef.current;
        if (topScrollBar) {
          const scrollBarContent = topScrollBar.querySelector("div");
          if (scrollBarContent) {
            scrollBarContent.style.width = `${getTableWidth()}px`;
          }
        }
      };

      // Products yüklenince güncelle
      updateScrollBarWidth();
    }
  }, [products]);

  const handleScroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 400;
      scrollRef.current.scrollLeft +=
        direction === "left" ? -scrollAmount : scrollAmount;
    }
  };

  // Ürünler yüklendiğinde ve sayfa değiştiğinde scroll bar'ları sıfırla ve tablo genişliğini güncelle
  useEffect(() => {
    const topScrollBar = topScrollBarRef.current;
    const tableContainer = tableContainerRef.current;

    if (topScrollBar && tableContainer) {
      // Scroll pozisyonlarını sıfırla
      topScrollBar.scrollLeft = 0;
      tableContainer.scrollLeft = 0;

      // 500ms sonra scroll bar genişliğini güncelle (tablonun tamamen oluşması için)
      const timer = setTimeout(() => {
        const scrollBarContent = topScrollBar.querySelector("div");
        if (scrollBarContent) {
          scrollBarContent.style.width = `${getTableWidth()}px`;
        }

        // Manual olarak senkronizasyonu tekrar kontrol et
        // Scroll olaylarını yeniden ata
        const handleTopScroll = () => {
          tableContainer.scrollLeft = topScrollBar.scrollLeft;
        };

        const handleTableScroll = () => {
          topScrollBar.scrollLeft = tableContainer.scrollLeft;
        };

        // Önce eski olayları temizle
        topScrollBar.removeEventListener("scroll", handleTopScroll);
        tableContainer.removeEventListener("scroll", handleTableScroll);

        // Yeni olayları ekle
        topScrollBar.addEventListener("scroll", handleTopScroll);
        tableContainer.addEventListener("scroll", handleTableScroll);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [page, selectedPlace]);
  const handleSelect = async (place) => {
    if (place.id === selectedPlace?.id && place.type === selectedPlace?.type) {
      return;
    }
    setSelectedProducts([]);
    setPage(1);
    setLoading(true);
    setProducts(null);
    setSelectedPlace(place);
    setFilterProductName("");
    setFilterCategoryName("");
    setIsFilterActive(false);
    const requestBody = createRequestBody(place?.name, 1, "", "");
    try {
      const productResponse = await outWardService.fetchPlaceProduct(
        place.name,
        requestBody
      );
      setProducts(productResponse?.products);
      setTotalpage(productResponse?.totalPage);
      setLoading(false);
      fetchData(productResponse?.products, place);
      setTimeout(() => {
        const topScrollBar = topScrollBarRef.current;
        const tableContainer = tableContainerRef.current;
        if (topScrollBar && tableContainer) {
          topScrollBar.scrollLeft = 0;
          tableContainer.scrollLeft = 0;
          const scrollBarContent = topScrollBar.querySelector("div");
          if (scrollBarContent) {
            scrollBarContent.style.width = `${getTableWidth()}px`;
          }
        }
      }, 300);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const response = await marketplacesService.getMarketPlacesAccountsApi(
          userId,
          token
        );
        setMarketpleacesAllAccounts(response?.data?.data?.data);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            "Hesap bilgileri alınırken hata oluştu."
        );
      }
    };
    const fetchAccountsEcommerce = async () => {
      try {
        const response =
          await ecommercePlaceService.getEcommercePlaceAccountsApi(
            userId,
            token
          );
        setEcommerceAllAccounts(response?.data?.data?.data);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            "Hesap bilgileri alınırken hata oluştu."
        );
      }
    };
    fetchAccounts();
    fetchAccountsEcommerce();
  }, [userId]);

  const createRequestBody = (
    selectedPlaceName,
    newPage,
    productName = "",
    categoryName = ""
  ) => {
    const marketPlaceSettings = marketpleacesAccounts
      .filter((account) => account.marketPlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        marketPlaceId: account.marketPlaceId || 0,
        marketPlaceName: account.marketPlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    const ecommercePlaceSettings = ecommerceAccounts
      .filter((account) => account.ecommercePlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        ecommercePlaceId: account.ecommercePlaceId || 0,
        ecommercePlaceName: account.ecommercePlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    return {
      userId: userId,
      marketPlaceSetting: marketPlaceSettings,
      ecommercePlaceSetting: ecommercePlaceSettings,
      page: newPage,
      pageSize: pageSize,
      productName: productName,
      categoryName: categoryName,
    };
  };

  const handlePageChange = async (event, newPage) => {
    setPage(newPage);
    if (selectedPlace) {
      setLoading(true);
      const requestBody = createRequestBody(
        selectedPlace.name,
        newPage,
        isFilterActive ? filterProductName : "",
        isFilterActive ? filterCategoryName : ""
      );
      try {
        const productResponse = await outWardService.fetchPlaceProduct(
          selectedPlace.name,
          requestBody
        );
        setProducts(productResponse?.products);
        setTotalpage(productResponse?.totalPage);
        setLoading(false);

        fetchData(productResponse?.products, selectedPlace);
      } catch {
        setLoading(false);
      }
    }
  };

  const handleMatch = (product) => {
    setSelectedMatchingProduct(product);
    handleOpenMatchingModal();
  };

  const handleAddAll = async (category, brand) => {
    try {
      setsendLoading(true);
      console.log("selectedProducts", selectedProducts);

      const productsToAdd = selectedProducts.map((product) => ({
        id: 0,
        supplierBarcode: product.barcode,
        suplierId: null,
        marketPlaceId:
          selectedPlace.type === "marketplace" ? selectedPlace.id : null,
        ecommercePlaceId:
          selectedPlace.type !== "marketplace" ? selectedPlace.id : null,
        brandId: brand,
        userId: userId,
        categoryId: category,
        quantity: product.quantity || 0,
        title: product.title,
        productMainId: product.productMainId,
        stockCode: product.stockCode || "",
        description: product.description,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        productBarcodes: allPlaces.map((place) => ({
          barcode: product.barcode,
          marketPlaceId: place.type === "marketplace" ? place.id : null,
          ecommercePlaceId: place.type !== "marketplace" ? place.id : null,
        })),
        productAttributes:
          product.attributes?.map((attr) => ({
            attributeValue: {
              name: attr.attributeValueName,
              mapAttrVName: attr.attributeValueName,
              attribute: {
                name: attr.attributeName,
                mapAttrName: attr.attributeName,
                userId: userId,
              },
            },
            varyantible: true,
          })) || [],
        productImages:
          product.images?.map((img) => ({ imageUrl: img.url })) || [],
           ecommerceProductId:product.ecommerceProductId || null,
        productPrices: allPlaces.map((place) => ({
          listPrice: product.listPrice || 0,
          salePrice: product.salePrice || 0,
          vatRate: product.vatRate || 0,
          marketPlaceId: place.type === "marketplace" ? place.id : null,
          ecommercePlaceId: place.type !== "marketplace" ? place.id : null,
         
        })),

        ia: true,
      }));
      const response = await productService.addPlacesProduct(productsToAdd);
      selectedProducts.forEach(async (product) => {
        try {
          setProducts((prevProducts) => {
            return prevProducts.map((p) => {
              if (p.barcode === product.barcode) {
                return {
                  ...p,
                  matching: "Eşleştirildi",
                };
              }
              return p;
            });
          });
        } catch (error) {
          console.error("Error in matchingControl:", error);
        }
      });
      setSelectedProducts([]);
      setIsAllSelected(false);
      showSuccessAlertAllNoReload();
      setsendLoading(false);
    } catch (error) {
      setsendLoading(false);
      showErrorAlertAll();
    }
  };
  const handleProductSelect = (product) => {
    setSelectedProducts((prevSelected) => {
      const isCurrentlySelected = prevSelected.some(
        (p) => p.barcode === product.barcode
      );
      if (isCurrentlySelected) {
        return prevSelected.filter((p) => p.barcode !== product.barcode);
      } else {
        return [...prevSelected, product];
      }
    });
  };

  const handleSelectAll = () => {
    // Var olmayan ürünlerin sayısını kontrol et
    const nonExistingProducts = products
      ? products.filter(
          (product) =>
            !product.pcIsExsist && product?.matching != "Eşleştirildi"
        )
      : [];

    // Eğer tüm var olmayan ürünler zaten seçiliyse, seçimi kaldır
    if (selectedProducts.length === nonExistingProducts.length) {
      setIsAllSelected(false);
      setSelectedProducts([]);
    } else {
      // Değilse, tüm var olmayan ürünleri seç
      setIsAllSelected(true);
      setSelectedProducts(nonExistingProducts);
    }
  };

  const setProduct = async (product) => {
    setSelectedProducts([]);
    setSelectedProducts([product]);
  };

  const handleProductSelectAndSave = async (product) => {
    await setProduct(product);
    handleOpenModal();
  };

  const matchingControl = async (model) => {
    try {
      const response = await productService.matchingControl(model);
      return response;
    } catch (exx) {}
  };

  const fetchData = async (products, place) => {
    products.forEach(async (product, index) => {
      const model = {
        barcode: product.barcode,
        stockCode:product.stockCode,
        userId: userId,
        marketPlaceId: place?.type === "marketplace" ? place?.id : null,
        ecommercePlaceId: place?.type !== "marketplace" ? place?.id : null,
        pageSize: 1,
        ecommerceProductId:product?.ecommerceProductId  || null,
      };

      try {
        const response = await matchingControl(model);
        setProducts((prevProducts) => {
          return prevProducts?.map((p) => {
            if (p.barcode === product.barcode) {
              return {
                ...p,
                matching:
                  response?.data == 1 ? "Eşleştirildi" : "Eşleştirilmedi",
              };
            }
            return p;
          });
        });
      } catch (error) {
        console.error("Error in matchingControl:", error);
      }
    });
  };

  const setAllProduct = (product) => {
    setProducts((prevProducts) => {
      return prevProducts?.map((p) => {
        if (p.barcode === product.barcode) {
          return {
            ...p,
            matching: "Eşleştirildi",
          };
        }
        return p;
      });
    });
  };

  // Filtre kutusunu aç/kapat
  const handleFilterToggle = () => {
    if (!filterOpen) {
      setFilterOpen(true);
      setShowFilterAlert(true);
    } else {
      setFilterOpen(false);
      setShowFilterAlert(false);
    }
  };

  // Listele butonuna tıklandığında filtreli arama başlasın
  const handleFilterList = () => {
    setIsFilterActive(true);
    fetchFilteredProducts(1);
  };

  // Listele butonuna tıklandığında ve sayfa değiştiğinde filtreli istek at
  const fetchFilteredProducts = async (newPage = 1) => {
    setLoading(true);
    try {
      if (!selectedPlace) return;
      const requestBody = createRequestBody(
        selectedPlace.name,
        newPage,
        filterProductName,
        filterCategoryName
      );
      const productResponse = await outWardService.fetchPlaceProduct(
        selectedPlace.name,
        requestBody
      );
      setProducts(productResponse?.products);
      setTotalpage(productResponse?.totalPage);
      // Filtreleme sonrası eşleştirme durumlarını kontrol et
      await fetchData(productResponse?.products, selectedPlace);
    } catch (err) {
      setError(err.message || "Filtreli ürünler alınırken hata oluştu.");
    }
    setLoading(false);
  };

  // Pagination'da filtre aktifse filtreli, değilse normal istek at
  const handlePaginationChange = async (event, newPage) => {
    setPage(newPage);
    setSelectedProducts([]);
    setIsAllSelected(false);
    if (isFilterActive) {
      await fetchFilteredProducts(newPage);
    } else {
      await handlePageChange(event, newPage);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        mb: 4,
        px: { xs: 0, sm: 1, md: 0 },
      }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          px: { xs: 1, sm: 2 },
          mt: { xs: 3, sm: 5 },
        }}
      >
        <Box
          sx={{
            padding: { xs: 1.5, sm: 2 },
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            justifyContent: "space-between",
            gap: { xs: 2, sm: 0 },
            mb: 3,
            backgroundColor: "#fff",
            borderRadius: 2,
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{ width: 4, height: 24, backgroundColor: "#b71c1c", mr: 1 }}
            />
            <Typography
              variant="h6"
              color="black"
              sx={{
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                fontSize: { xs: "1rem", sm: "1.25rem" },
              }}
            >
              Pazaryeri Ürünleri
            </Typography>
          </Box>
          <Button
            variant="outlined"
            size="small"
            onClick={handleOpenModal}
            disabled={selectedProducts?.length === 0 || sendLoading}
            sx={{
              display: "flex",
              justifyContent: "left",
              alignItems: "left",
              height: "100%",
              borderRadius: 2,
              textTransform: "none",
              width: { xs: "100%", sm: "auto" },
            }}
          >
            Toplu Ekle
          </Button>
        </Box>
      </Typography>

      {loadingPleaces ? (
        <LinearProgress />
      ) : (
        <SliderContainer>
          <ScrollButton direction="left" onClick={() => handleScroll("left")}>
            <ChevronLeft />
          </ScrollButton>

          <ScrollContainer ref={scrollRef}>
            {allPlaces.map((place) => (
              <StyledCard
                key={`${place.type}-${place.id}`}
                selected={
                  selectedPlace?.id === place.id &&
                  selectedPlace?.type == place.type
                }
                colorcode={place.colorCode}
                onClick={() => handleSelect(place)}
              >
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 1,
                  }}
                >
                  {place.iconLink ? (
                    <CardMedia
                      component="img"
                      image={place.iconLink}
                      alt={place.name}
                      referrerPolicy="no-referrer"
                      sx={{
                        width: 50,
                        height: 50,
                        objectFit: "contain",
                        mb: 1,
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: 50,
                        height: 50,
                        bgcolor: place.colorCode || "#f5f5f5",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        mb: 1,
                      }}
                    >
                      <Typography variant="body1" sx={{ color: "#fff" }}>
                        {place.name.charAt(0)}
                      </Typography>
                    </Box>
                  )}

                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      color: place.colorCode || "text.primary",
                      fontWeight: selectedPlace === place.id ? 600 : 400,
                    }}
                  >
                    {place.name}
                  </Typography>
                </Box>
              </StyledCard>
            ))}

            {/* Add New Card with Plus Sign */}
            <StyledCard
              key="add-new-place"
              colorcode="#1E88E5"
              onClick={() => (window.location.href = "/Application")}
              sx={{
                position: "relative",
                "&:hover::after": {
                  content: '"Yeni Pazaryeri Ekle"',
                  position: "absolute",
                  bottom: "-30px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "rgba(0,0,0,0.7)",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                  zIndex: 1000,
                },
              }}
            >
              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  p: 1,
                }}
              >
                <Box
                  sx={{
                    width: 50,
                    height: 50,
                    bgcolor: "#1E88E5", // Blue color from the image
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    mb: 1,
                  }}
                >
                  <Typography variant="h5" sx={{ color: "#fff" }}>
                    +
                  </Typography>
                </Box>

                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    color: "#1E88E5", // Blue color from the image
                    fontWeight: 500,
                  }}
                >
                  Ekle
                </Typography>
              </Box>
            </StyledCard>
          </ScrollContainer>

          <ScrollButton direction="right" onClick={() => handleScroll("right")}>
            <ChevronRight />
          </ScrollButton>
        </SliderContainer>
      )}

      {/* Filtre kutusu */}
      <Box
        sx={{
          mt: 2,
          mb: 2,
          px: { xs: 1, sm: 0 },
        }}
      >
        <Button
          variant="outlined"
          onClick={handleFilterToggle}
          fullWidth
          sx={{
            mb: { xs: 2, sm: 0 },
            display: { xs: "block", sm: "inline-block" },
          }}
        >
          {filterOpen ? "Filtreyi Kapat" : "Filtrele"}
        </Button>
        {showFilterAlert && (
          <Alert severity="info" sx={{ mt: 2 }}>
            İlk arama yavaş olabilir, sonraki arama işlemleri hızlı
            çalışacaktır. Filtreleme işlemlerinin sağlıklı bir şekilde
            gerçekleştirilebilmesi için tüm ürünlerin sisteme eksiksiz olarak
            yüklenmiş olması gerekmektedir.
          </Alert>
        )}
        {filterOpen && (
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              alignItems: { xs: "stretch", sm: "center" },
              mt: 2,
            }}
          >
            <TextField
              label="Ürün Adı"
              value={filterProductName}
              onChange={(e) => setFilterProductName(e.target.value)}
              size="small"
              fullWidth
            />
            <TextField
              label="Kategori Adı"
              value={filterCategoryName}
              onChange={(e) => setFilterCategoryName(e.target.value)}
              size="small"
              fullWidth
            />
            <Button
              variant="contained"
              onClick={handleFilterList}
              fullWidth
              sx={{
                minWidth: { xs: "100%", sm: "120px" },
              }}
            >
              Listele
            </Button>
          </Box>
        )}
      </Box>

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
        open={sendLoading}
      >
        <CircularProgress color="inherit" />

        <div style={{ marginLeft: "10px" }}>Kaydediliyor...</div>
      </Backdrop>

      <TableContainer
        component={Paper}
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          overflow: "hidden",
          "& .MuiTableCell-root": {
            whiteSpace: "nowrap",
            [theme.breakpoints.down("sm")]: {
              padding: "8px 4px",
              fontSize: "0.75rem",
            },
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Üst scroll bar */}
          <Box
            sx={{
              overflowX: "auto",
              mb: 1,
              mt: 1,
              pb: 1, // Scroll bar için biraz alt boşluğu
              "&::-webkit-scrollbar": {
                height: "10px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0,0,0,0.3)",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.5)",
                },
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "rgba(0,0,0,0.05)",
                borderRadius: "8px",
              },
            }}
            className="top-scroll-bar"
            ref={topScrollBarRef}
            onScroll={(e) => {
              if (tableContainerRef.current) {
                tableContainerRef.current.scrollLeft = e.target.scrollLeft;
              }
            }}
          >
            <Box
              sx={{
                minWidth: "max-content",
                width: `${getTableWidth()}px`,
                height: "1px",
              }}
            ></Box>
          </Box>
          <Box
            sx={{ overflow: "auto" }}
            ref={tableContainerRef}
            onScroll={(e) => {
              if (topScrollBarRef.current) {
                topScrollBarRef.current.scrollLeft = e.target.scrollLeft;
              }
            }}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: "grey.50" }}>
                  <TableCell
                    padding="checkbox"
                    sx={{ width: { xs: "40px", sm: "auto" } }}
                  >
                    <Checkbox
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                      indeterminate={
                        selectedProducts.length > 0 &&
                        selectedProducts.length < products?.length
                      }
                      size={isMobile ? "small" : "medium"}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      display: { xs: "none", md: "table-cell" },
                    }}
                  >
                    Barkod
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Ürün</TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      display: { xs: "none", sm: "table-cell" },
                    }}
                  >
                    Marka
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      display: { xs: "none", lg: "table-cell" },
                    }}
                  >
                    Stok Kodu
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, textAlign: "right" }}>
                    Fiyat
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      textAlign: "center",
                      display: { xs: "none", sm: "table-cell" },
                    }}
                  >
                    Durum
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      display: { xs: "none", lg: "table-cell" },
                    }}
                  >
                    Kategori
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      display: { xs: "none", xl: "table-cell" },
                    }}
                  >
                    Özellikler
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Eşleşme</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Stok</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>İşlemler</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={10} sx={{ height: 400 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <CircularProgress />
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : !products ? (
                  <TableRow>
                    <TableCell colSpan={10} sx={{ height: 400 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <Typography color="text.secondary">
                          Ürün bulunamadı
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  products.map((product) => (
                    <TableRow
                      key={product.id}
                      sx={{
                        "&:hover": { bgcolor: "action.hover" },
                        bgcolor: product.pcIsExsist
                          ? "rgba(200, 200, 200, 0.3)"
                          : "transparent",
                      }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedProducts.some(
                            (p) => p.barcode === product.barcode
                          )}
                          onChange={() => handleProductSelect(product)}
                          disabled={
                            product.pcIsExsist ||
                            product?.matching == "Eşleştirildi"
                          }
                          size={isMobile ? "small" : "medium"}
                        />
                      </TableCell>
                      <TableCell
                        sx={{
                          display: { xs: "none", md: "table-cell" },
                          fontFamily: "monospace",
                        }}
                      >
                        {product.barcode}
                      </TableCell>
                      <TableCell>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: { xs: "column", sm: "row" },
                            gap: { xs: 1, sm: 2 },
                          }}
                        >
                          <Avatar
                            src={product?.images[0]?.url}
                            alt={product?.title}
                            variant="square"
                            slotProps={{ img: { referrerPolicy: "no-referrer" } }}
                            sx={{
                              width: { xs: 40, sm: 50 },
                              height: { xs: 40, sm: 50 },
                            }}
                          />
                          <div>
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: "bold",
                                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                              }}
                            >
                              {product.title}
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{
                                display: { xs: "none", sm: "block" },
                                color: "gray",
                              }}
                            >
                              Stok Kodu: {product.stockCode}
                            </Typography>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell
                        sx={{
                          display: { xs: "none", sm: "table-cell" },
                        }}
                      >
                        {product.brandName}
                      </TableCell>
                      <TableCell
                        sx={{
                          display: { xs: "none", lg: "table-cell" },
                        }}
                      >
                        {product.stockCode}
                      </TableCell>
                      <TableCell align="right">
                        {product.salePrice?.toLocaleString("tr-TR", {
                          style: "currency",
                          currency: "TRY",
                        })}
                      </TableCell>
                      <TableCell
                        sx={{
                          display: { xs: "none", sm: "table-cell" },
                          textAlign: "center",
                        }}
                      >
                        <Box
                          sx={{
                            display: "inline-flex",
                            px: 1,
                            py: 0.5,
                            borderRadius: "full",
                            bgcolor: product.approved
                              ? "success.50"
                              : "warning.50",
                            color: product.approved
                              ? "success.700"
                              : "warning.700",
                          }}
                        >
                          <Typography variant="caption" fontWeight="medium">
                            {product.approved ? "Onaylandı" : "Onay Bekliyor"}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          display: { xs: "none", lg: "table-cell" },
                        }}
                      >
                        {product.categoryName}
                      </TableCell>
                      <TableCell
                        sx={{
                          display: { xs: "none", xl: "table-cell" },
                        }}
                      >
                        {product.attributes?.map((attr, index) => (
                          <Typography
                            key={index}
                            variant="caption"
                            display="block"
                          >
                            {attr.attributeName}: {attr.attributeValueName}
                          </Typography>
                        ))}
                      </TableCell>
                      <TableCell>
                        {product?.matching == null ? (
                          <CircularProgress size={20} />
                        ) : product?.matching == "Eşleştirildi" ? (
                          <CheckCircle
                            sx={{
                              color: "green",
                              fontSize: { xs: 20, sm: 24 },
                            }}
                          />
                        ) : (
                          <Cancel
                            sx={{ color: "red", fontSize: { xs: 20, sm: 24 } }}
                          />
                        )}
                      </TableCell>
                      <TableCell>{product.quantity}</TableCell>
                      <TableCell>
                        {product.pcIsExsist ? (
                          <Typography
                            variant="caption"
                            color="success.main"
                            sx={{ fontWeight: 600 }}
                          >
                            Ürün sistemde mevcut
                          </Typography>
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: { xs: "column", sm: "row" },
                              gap: 1,
                            }}
                          >
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={() => handleMatch(product)}
                              disabled={
                                product.pcIsExsist ||
                                product?.matching == "Eşleştirildi"
                              }
                              sx={{
                                borderRadius: 2,
                                textTransform: "none",
                                minWidth: { xs: "100%", sm: "auto" },
                              }}
                            >
                              Eşleştir
                            </Button>
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={() =>
                                handleProductSelectAndSave(product)
                              }
                              disabled={
                                product.pcIsExsist ||
                                product?.matching == "Eşleştirildi"
                              }
                              sx={{
                                borderRadius: 2,
                                textTransform: "none",
                                minWidth: { xs: "100%", sm: "auto" },
                              }}
                            >
                              Ekle
                            </Button>
                          </Box>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </Box>
        </Box>
      </TableContainer>
      <Stack
        spacing={2}
        sx={{
          mt: 2,
          display: "flex",
          alignItems: "center",
          "& .MuiPagination-ul": {
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 1,
          },
        }}
      >
        <Pagination
          count={totalPage}
          page={page}
          onChange={handlePaginationChange}
          color="primary"
          size={isMobile ? "small" : "large"}
          showFirstButton
          showLastButton
        />
      </Stack>
      <AddCategory
        open={openCategoryAdd}
        handleClose={handleCloseModal}
        handleAddAll={handleAddAll}
      />

      <ProductMatchingModal
        open={openProductMatching}
        handleClose={handleCloseMatchingModal}
        product={selectedMatchingProduct}
        pleaces={selectedPlace}
        setAllProduct={setAllProduct}
      />
    </Box>
  );
};
export default PlaceProducts;
